import { render, staticRenderFns } from "./CsvDownload.vue?vue&type=template&id=22adedd6"
import script from "./CsvDownload.vue?vue&type=script&lang=js"
export * from "./CsvDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports